import type { ModuleInverterCompatibilityData } from "@logic/lib/powur-os"

import type { DEFAULT_SELECTED_MODULE } from "~/containers/LegacyDesigner/state/elements/panels"

import {
  getSolarModuleFromDesignEquipment,
  getSystemSizeInWatts,
  type Design,
  type Equipment,
} from "./design-model"

type SolarModuleLike = {
  id: number
  name: string
  width?: number | null
  height?: number | null
  isDefault?: boolean | null
  currentProposalPrice?: number | null
  wattage?: number | null
  manufacturer?: string | { name?: string | null } | null
  moduleData?: ModuleInverterCompatibilityData | null
}

export const getSolarModuleEquipmentFromDesign = (
  design: Pick<Design, `designEquipment`>,
): Equipment | null =>
  getSolarModuleFromDesignEquipment(design.designEquipment)?.equipment ?? null

export const getSolarModuleIdFromDesign = (
  design: Pick<Design, `designEquipment`>,
): number | null => getSolarModuleEquipmentFromDesign(design)?.id ?? null

export const mapSolarModuleToSelectedModule = (
  solarModule: SolarModuleLike,
): typeof DEFAULT_SELECTED_MODULE => ({
  currentProposalPrice: solarModule.currentProposalPrice ?? 0,
  height: solarModule.height ?? NaN,
  id: solarModule.id,
  isDefault: solarModule.isDefault ?? false,
  manufacturer:
    typeof solarModule.manufacturer === `string`
      ? solarModule.manufacturer
      : (solarModule.manufacturer?.name ?? ``),
  name: solarModule.name,
  moduleData: solarModule.moduleData ?? null,
  visionId: String(solarModule.id),
  wattage: solarModule.wattage ?? 0,
  width: solarModule.width ?? NaN,
})

export const getSystemSizeInWattsFromDesign = (
  design: Pick<
    Design,
    | `designEquipment`
    | `installAreasToPanels`
    | `panels`
    | `source`
    | `systemSizeKw`
  >,
): number => {
  if (design.source === `aurora`) {
    return typeof design.systemSizeKw === `number` &&
      Number.isFinite(design.systemSizeKw) &&
      design.systemSizeKw > 0
      ? design.systemSizeKw * 1000
      : 0
  }

  return getSystemSizeInWatts({
    installAreasToPanels: design.installAreasToPanels,
    panels: design.panels,
    solarModule: getSolarModuleEquipmentFromDesign(design),
  })
}
